<template>
    <div class="paragraph" v-if="commontInfo.comments[0]">
        <strong><a :href="commontInfo.more_comment_link" target="_blank" @click="countAd(4200)"><em>{{commontInfo.name}}</em>的车主点评</a></strong>
            <div class="czdp">
                <p class="boldBlue"><i>车型：</i><a :href="commontInfo.comments[0].link" target="_blank" @click="countAd(4201)">{{commontInfo.comments[0].name}}</a></p>
                <p class="jghy">
                    <span class="sp1"><i>裸车价格：</i>{{commontInfo.comments[0].price}}</span>
                    <span class="sp2"><i>耗油：</i>{{commontInfo.comments[0].yh}}</span>
                    <span class="sp3">
                        <i>评分：</i>
                        <em class="xingxingbai"></em>
                        <em class="xingxing" :style="`width: ${starsWidth}px;`"></em>
                        <em class="number">{{commontInfo.comments[0].score}}</em>
                    </span>
                    <span class="sp4"><a :href="commontInfo.comments[0].link" target="_blank" @click="countAd(4202)">详细 &gt;&gt;</a></span>
                </p>
                <p><i class="good">优点：</i>{{commontInfo.comments[0].virtue}}</p>
                <p><i class="bad">缺点：</i>{{commontInfo.comments[0].demerit}}</p>
            </div>
        <a :href="commontInfo.more_comment_link" target="_blank" class="moreLink" @click="countAd(4203)">更多点评 &gt;&gt;</a>
    </div>
</template>

<script>
    export default {
        name: 'Review',
        props: {
            commontInfo: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            starsWidth() {
                return ((this.commontInfo.comments[0].score / 5) *80).toFixed(1)
            }
        }
    }
</script>

<style lang="scss" scoped>
.paragraph {
      strong {
        font-weight: normal;
        font-size: 16px;
        line-height: 32px;    
        a {
            text-decoration: underline;
            color: #225599;            
        }      
        em {
            color: #cc0000;
            text-decoration: underline;
            font-style: normal;
        }
      }
      .czdp {
            color: #333333;
            border-bottom: 1px dashed #e4e4e4;
            padding-bottom: 10px;
            p {
                line-height: 22px;
                height: 22px;
                overflow: hidden;   
            }
                i {
                    color: #777777;
                    font-style: normal;
                }
            .boldBlue {
                a {
                     color: #225599;
                    font-weight: bold; 
                }
            }
        }
        .jghy {
            .sp1 {
                display: inline-block;
                width: 150px;
            }
            .sp2 {
                display: inline-block;
                width: 140px;
            }
            .sp3 {
                display: inline-block;
                position: relative;
                width: 250px;
                .xingxingbai {
                    position: absolute;
                    display: block;
                    width: 80px;
                    height: 12px;
                    top: 4px;
                    left: 35px;
                    background: url($imageURL) no-repeat;
                    background-position: 0 -373px;
                }
                .xingxing {
                    position: absolute;
                    display: block;
                    height: 12px;
                    top: 4px;
                    left: 35px;
                    background: url($imageURL) no-repeat;
                    background-position: 0 -361px;                    
                }
                .number {
                    position: absolute;
                    display: block;
                    width: 30px;
                    height: 20px;
                    line-height: 20px;
                    font-weight: bold;
                    top: 0;
                    left: 125px;
                    color: #cc0000;
                    text-decoration: none!important;
                    font-style: normal;
                }
            }
            .sp4 {
                a {
                    color: #225599;
                    text-decoration: underline;
                }
            }
        }
        .good {
            color: #090!important;
        }
        .bad {
            color: red!important;
        }
        .moreLink {
            margin-top: 14px;
            display: inline-block;
            line-height: 14px;
            height: 14px;
            text-decoration: underline;
            color: #225599;
        }
}
</style>